

const ComingSoon = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <h1>The website page is under development</h1>
        </div>
    );
}

export default ComingSoon;